module.exports = __webpack_public_path__ + "media/images/app-discover-screen-a586c6f93c87abae81a31470af9d5962.png";